import _ from 'lodash'

import { useLevelPlaySurface } from '@/shared/level-play'

import { WordHuntGame } from './Game'


export const LevelPlayWordHunt = ({ activity }) => {
  const { onComplete, loseHeart } = useLevelPlaySurface()
  const { meta } = activity
  const words = _.get(meta, 'words', []).map(words =>
    _.truncate(words.name.toUpperCase(), { length: 10, omission: '' })
  )

  return (
    <WordHuntGame
      wordsList={words}
      showWords={meta.show_words}
      onComplete={() =>
        onComplete({
          uid: activity.uid,
          answer: `Palavras encontradas: ${words.join(', ')}`
        })
      }
      onError={loseHeart}
    />
  )
}
